import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { stringify } from '@angular/core/src/util';
import { EndpointService, HttpErrorHandlingService } from '@app/core';
import { Asignacion, Const, RadicadoCita, Rol, Tarea } from '@app/shared';
import { environment } from '@env/environment';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';

/**
 * Modelo de un año de radicados
 *
 * @export
 * @interface RadicationYear
 */
export interface RadicationYear {
  anio: number;
}

/**
 * Modelo de la generación de radicados
 *
 * @export
 * @interface GenerateRadication
 */
export interface GenerateRadication {
  clasificacion_documentos: number;
  documento_cita: string;
  fecha: Date;
  folios: number;
  id: number;
  id_documento_cita: number;
  radicado: string;
}

export interface Sticker {
  id?: number;
  nombre?: string;
  tipo_documental?: TipoDocumental;
}

export interface TipoDocumental {
  id: number;
  nombre: string;
  codigo: string;
  expediente: boolean;
  subserie: number;
}

const radicacion_cinco = environment.radicacion_cinco;

@Injectable()
export class InternalTaskInformationDataService {
  PATH_SERVICES = Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.services;
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService, private hehs: HttpErrorHandlingService) {}

  /**
   * actualiza la actividad
   *
   * @param {Actividad} activity
   * @return {*}  {Promise<Actividad>}
   * @memberof ActivityService
   */
  taskUpdate(task: Tarea, action?: string, responsables?: any, asign?: boolean, document_id?: number): Promise<Tarea> {
    const path = this.PATH_SERVICES + Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.endpoints.services;
    let dataForm = {};
    if(action == 'modificar_datos'){
      dataForm = {
        accion: action,
        tarea_id: task.id,
        datos: {
          estado_id: task.tarea_estado,
          fecha_inicio: task.fecha_registro = "" ? null :   task.fecha_registro,
          fecha_finalizacion: task.fecha_finalizacion = "" ? null :  task.fecha_finalizacion
        }
      };
    }else if((action == 'activar')|| (action == 'inactivar')){
      dataForm = {
        accion: action,
        tarea_id: task.id,
      };
    }else if(action == "cambiar_responsables" && asign){
      dataForm = {
        accion: action, 
        tarea_id: task.id,
        responsables : {
          asignar: responsables,
          remover: []
        }
      }
    }else if(action == "cambiar_responsables" && !asign){
      dataForm = {
        accion: action, 
        tarea_id: task.id,
        responsables : {
          asignar: [],
          remover: responsables
        }
      }
    }else if(action == 'documentos'){
      dataForm = {
        accion: action,
        tarea_id: task.id,
        datos: {
          accion_documento: 'desasociar',
          documento_id: document_id
        }
      }
    }
    return new Promise((resolve, reject) => {
      this.http.post<Tarea>(this.api.addParams(path, 'simple', []), dataForm).subscribe(
        data => {
          resolve(data);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Consulta el historial de asignaciones
   *
   * @param {number} id
   * @returns {Observable<Asignacion>}
   * @memberof AssignmentService
   */
  getHistoryAssign(id: number): Observable<Asignacion> {
    return new Observable(obs => {
      this.http.get<Asignacion>(this.api.get('historyTask', [id])).subscribe(
        res => {
          obs.next(res);
          obs.complete();
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  
   /**
    *Consulta los años de los radicados disponibles en cita o CINCO
    *
    * @param {string} idTrd
    * @param {number} [id_tipo_documental]
    * @return {*}  {Observable<RadicationYear[]>}
    * @memberof InternalTaskInformationDataService
    */
   getRadicationYears(idTrd: string, id_tipo_documental?: number): Observable<RadicationYear[]> {
    const formData = new FormData();

    formData.append("idtrd", idTrd);

    if (radicacion_cinco) {
      return new Observable((obs) => {
        this.http.get<RadicationYear[]>(this.api.get("anios_radicados", [id_tipo_documental])).subscribe(
          (res) => {
            obs.next(res);
          },
          (err) =>
            this.hehs.error(err, () => {
              obs.error(err);
            })
        );
      });
    } else {
      return new Observable((obs) => {
        this.http
          .skipErrorHandler()
          .post<RadicationYear[]>(Const.ROUTES_SYSTEM_INTEGRATIONS.cita.index, formData, {
            observe: "response",
          })
          .subscribe(
            (res) => {
              obs.next(res.body);
            },
            (err) =>
              this.hehs.error(err, () => {
                obs.error(err);
              })
          );
      });
    }
  }

    /**
   * Consulta los años de los radicados disponibles en por serie y subserie
   *
   * @param {string} idTrd
   * @returns {Observable<RadicadoCita[]>}
   * @memberof InternalTaskInformationDataService
   */
     getRadicationYearsBySerie(asociacion: any): Observable<RadicationYear[]> {
      const formData = new FormData();
      if(asociacion){
        let listSerie: any[] = [];
        let listSubserie: any[] = [];
        asociacion.forEach((element: { subserie: any; serie: any; }) => {
          if(element.subserie){
            listSubserie.push(element.subserie);
          }else{
            listSerie.push(element.serie);
          }
        });
        if(listSerie.length){
          formData.append('serie', JSON.stringify(listSerie));
        }
        if(listSubserie.length){
          formData.append('subserie', JSON.stringify(listSubserie));
        }
      }
      return new Observable((obs) => {
        this.http.post<RadicationYear[]>(this.api.get('associateRadicationUtilitiesService'), formData).subscribe(
          (res) => {
            obs.next(res);
          },
          (err) =>
            this.hehs.error(err, () => {
              obs.error(err);
            })
        );
      });
    }

  /**
   * Ejecuta la radicacion del documento
   *
   * @param {*} formData
   * @param {number} [iddocumento]
   * @returns {Promise<GenerateRadication>}
   * @memberof RadicationDocsDataService
   */
  setRadication(formData: any, iddocumento?: number): Promise<GenerateRadication> {
    return new Promise((resolve, reject) => {
      const action = iddocumento ? 'put' : 'post';

      this.http.skipErrorHandler()
        [action]<GenerateRadication>( this.api.get('radicationDocument', [iddocumento]), formData, {
            observe: 'response'
          }
        )
        .subscribe(
          res => {
            this.toastr.success(`Documento radicado correctamente`, 'Operación exitosa');
            resolve(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error(
                'Lo sentimos el documento no se ha podido asociar al expediente',
                'Falla de radicación'
              );
            }
            reject(false);
          }
        );
    });
  }

  /**
   * Genera el radicado del documento
   *
   * @param {number} folios
   * @param {number} idTarea
   * @param {number} classificationDocument
   * @param {Array<any>} [indices]
   * @returns {Promise<GenerateRadication>}
   * @memberof RadicationDocsDataService
   */
  generateRadication(
    folios: number,
    idTarea: number,
    classificationDocument: number,
    indices?: Array<any>,
    radicate?: string,
    dateRadicate?: Date | string
  ): Promise<GenerateRadication> {
    const dataForm = {
      folios: folios,
      tarea: idTarea,
      clasificacion_documentos: classificationDocument,
    };
    if (indices && indices.length) {
      dataForm['indices'] = indices;
    }
    if (radicate && dateRadicate) {
      dataForm['radicado'] = radicate;
      let date: Date;
      if (typeof dateRadicate === 'string') {
        date = new Date(dateRadicate);
      } else {
        date = dateRadicate;
      }
      const moment = require('moment');
      dataForm['fecha'] = moment(date).format('YYYY-MM-DD HH:mm:ss');
    }
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
        .post<GenerateRadication>(this.api.get('generateRadicationCita'),  dataForm, {
          observe: 'response'
        })
        .subscribe(
          res => {
            this.toastr.success(`Documento radicado correctamente`, 'Operación exitosa');
            resolve(res.body);
          },
          err =>
            this.hehs.error(err, () => {
              if (err.status !== 401 && err.status !== 403) {
                if (err.error['message'] && err.status !== 500) {
                  this.toastr.error(err.error['message'], 'Error en radicación');
                } else if (err.error['Error'] && err.status !== 500) {
                  this.toastr.error(err.error['Error'], 'Error en radicación');
                } else if (err.status !== 500) {
                  this.toastr.error('Lo sentimos ha ocurrido un error inesperado', 'Error en radicación');
                }
              }
              reject(err);
            })
        );
    });
  }

  
   /**
    *Consulta los radicados de cita o cinco
    *
    * @param {number} year
    * @param {number} idTrd
    * @param {number} [consecutive=0]
    * @param {number} [idDocument=-1]
    * @param {number} [id_tipo_documental]
    * @return {*}  {Observable<RadicadoCita[]>}
    * @memberof InternalTaskInformationDataService
    */
   getRadicationsCita(
    year: number,
    idTrd: number,
    consecutive: number = 0,
    idDocument: number = -1,
    id_tipo_documental?: number,
    propiedades_asociacion?: any
  ): Observable<RadicadoCita[]> {
    const formData = new FormData();

    if(radicacion_cinco){
      formData.append('year', String(year));
      formData.append('tipo_documental', String(id_tipo_documental))
      if(propiedades_asociacion){
        let listSerie: any[] = [];
        let listSubserie: any[] = [];
        propiedades_asociacion.forEach((element: { subserie: any; serie: any; }) => {
          if(element.subserie){
            listSubserie.push(element.subserie);
          }else{
            listSerie.push(element.serie);
          }
        });
        if(listSerie.length){
          formData.append('serie', JSON.stringify(listSerie));
        }
        if(listSubserie.length){
          formData.append('subserie', JSON.stringify(listSubserie));
        }
      }
    }else{
      formData.append("anio", String(year));
      formData.append("idtrd", String(idTrd));

      if (idDocument !== -1) {
        formData.append("iddocumento", String(idDocument));
      }

      if (consecutive) {
        formData.append("consecutivo", String(consecutive));
      }
    }

    if (radicacion_cinco) {
      return new Observable((obs) => {
        this.http
          .skipErrorHandler()
          .post<RadicadoCita[]>(this.api.get("anios_radicados"), formData, {
            observe: "response",
          })
          .subscribe(
            (res) => {
              obs.next(res.body);
            },
            (err) =>
              this.hehs.error(err, () => {
                obs.error(err);
              })
          );
      });
    } else {
      return new Observable((obs) => {
        this.http
          .skipErrorHandler()
          .post<RadicadoCita[]>(Const.ROUTES_SYSTEM_INTEGRATIONS.cita.index, formData, {
            observe: "response",
          })
          .subscribe(
            (res) => {
              obs.next(res.body);
            },
            (err) =>
              this.hehs.error(err, () => {
                obs.error(err);
              })
          );
      });
    }
  }

  /**
   * Servicio encargado de subir los archivos
   *
   * @param {FormData} formData
   * @returns {Observable<any>}
   * @memberof RadicationDataService
   */
  uploadFile(formData: FormData): Observable<any> {
    return new Observable(obs => {
      this.http
        .post(this.api.get('docsInstance'),  formData, {
          observe: 'response'
        })
        .subscribe(
          res => {
            if (res.status === 201) {
              obs.next(res.body);
              this.toastr.success('Archivos subidos correctamente.', 'Operación exitosa');
            } else {
              obs.next({});
            }
          },
          err =>
            this.hehs.error(err, () => {
              obs.error(err);
            })
        );
    });
  }

  /**
   * Consulta un rol(grupo).
   *
   * @param {number} idRol
   * @returns {Observable<Rol>}
   * @memberof AssignmentService
   */
  getRole(idRol: number): Observable<Rol> {
    return this.http.get<Rol>(this.api.get('roles', [idRol]));
  }

   /**
    *Obtiene los stickers por el tipo documental
    *
    * @param {number} id
    * @return {*}  {Observable<Sticker[]>}
    * @memberof InternalTaskInformationDataService
    */
   getStickers(id: number): Observable<Sticker[]> {
    return new Observable((obs) => {
      this.http.get<Sticker[]>(this.api.get("sticker_document", [id])).subscribe(
        (sticker) => {
          obs.next(sticker);
        },
        (err) => {
          obs.error(err);
        }
      );
    });
  }

 
   /**
    *Descargar el sticker por el tipo documental
    *
    * @param {number} id_tarea
    * @param {number} sticker_id
    * @param {number} [clasificacion]
    * @return {*}  {Observable<any>}
    * @memberof InternalTaskInformationDataService
    */
   downloadSticker(id_tarea: number, sticker_id: number, clasificacion?: number): Observable<any> {
    let data = {
      tarea: id_tarea,
      clasificacion: clasificacion,
      sticker_id: sticker_id,
    };
    return new Observable((obs) => {
      this.http
        .post<any>(this.api.get("generateStickerDoc"), data, {
          observe: "response",
        })
        .subscribe(
          (res) => {
            if (res.status === 200 || res.status === 201) {
              obs.next(res);
              this.toastr.success("Rótulo descargado exitosamente.", "Operación exitosa");
            } else {
              obs.next({});
            }
          },
          (err) =>
            this.hehs.error(err, () => {
              obs.error(err);
            })
        );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/utilitarios-flow/internal-task-information/shared/internal-task-information.data.service.ts